import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'

export type JanusConnectionState = 'initial' | 'connecting' | 'connected' | 'disconnected' | 'failed' | 'closed'

export interface JanusReducer {
  connectionState: JanusConnectionState
  roomCreated: boolean
}

const initialState: JanusReducer = {
  connectionState: 'initial',
  roomCreated: false
}

export interface SetConnectionStateAction {
  state: JanusConnectionState
}
export const SET_CONNECTION_STATE = createAction<SetConnectionStateAction>('janus_reducer/set_connection_state')

interface CreateRoomPayload {
  id: string
}
export type CreateRoomActionType = PayloadAction<CreateRoomPayload>
export const CREATE_ROOM = createAction<CreateRoomPayload>('janus_reducer/create_room')
export const SET_ROOM_CREATED = createAction<boolean>('janus_reducer/set_room_created')
export const RESET_ROOM_CREATED = createAction('janus_reducer/reset_room_created')

export const janusReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_CONNECTION_STATE, (state, action) => {
      return { ...state, connectionState: action.payload.state }
    })
    .addCase(SET_ROOM_CREATED, (state, action) => {
      return { ...state, roomCreated: action.payload }
    })
    .addCase(RESET_ROOM_CREATED, (state) => {
      return { ...state, roomCreated: false }
    })
})
